import { render, staticRenderFns } from "./editexternalaccess.vue?vue&type=template&id=7666be7c"
import script from "./editexternalaccess.vue?vue&type=script&lang=js"
export * from "./editexternalaccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports